/* =========================================================
   Flexi Canap · Fiche produit en blocs : badges et onglets
   (complète fp-produit.js ; se relance quand l'éditeur ou le changement de couleur reconstruit la fiche)
   ========================================================= */
(function () {
  'use strict';
  if (window.FPB) return;
  window.FPB = true;
  function chaque(l, f) { Array.prototype.forEach.call(l, f); }
  function enfants(z, sel) { return Array.prototype.filter.call(z.children, function (e) { return e.matches(sel); }); }

  /* ----- Badges en verre : le reflet suit le pointeur, un toucher ouvre le détail ----- */
  function badges(zone) {
    if (zone.hasAttribute('data-pret')) return;
    zone.setAttribute('data-pret', '');
    var liste = zone.querySelectorAll('.fp-badge'), detail = zone.querySelector('.fp-badges__detail'), texte = zone.querySelector('[data-fpb-badge-texte]');
    chaque(liste, function (b) {
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.setProperty('--x', (e.clientX - r.left) + 'px'); b.style.setProperty('--y', (e.clientY - r.top) + 'px'); });
      b.addEventListener('click', function () {
        var ouvert = b.getAttribute('aria-expanded') === 'true';
        chaque(liste, function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (ouvert || !b.getAttribute('data-detail')) { detail.classList.remove('fp-ouvert'); return; }
        b.setAttribute('aria-expanded', 'true');
        if (detail.classList.contains('fp-ouvert')) { texte.style.opacity = 0; setTimeout(function () { texte.textContent = b.getAttribute('data-detail'); texte.style.opacity = 1; }, 150); }
        else { texte.textContent = b.getAttribute('data-detail'); detail.classList.add('fp-ouvert'); }
      });
    });
  }

  /* ----- Onglets : trait qui glisse, contenus en fondu ----- */
  function onglets(zone) {
    if (zone.hasAttribute('data-pret')) return;
    /* les onglets sont dans des enveloppes Shopify : on les cherche en profondeur */
    var boutons = [].slice.call(zone.querySelectorAll('.fp-onglet')), panneaux = [].slice.call(zone.querySelectorAll('.fp-panneau')), trait = enfants(zone, '.fp-onglets__trait')[0];
    if (boutons[0]) boutons[0].setAttribute('data-premier', '');
    /* colonne explicite : le trait occupe la première case de la ligne */
    boutons.forEach(function (b, k) { b.style.gridColumn = String(k + 1); });
    zone.style.setProperty('--fp-nb', Math.max(1, boutons.length));
    function activer(k) {
      boutons.forEach(function (b, j) { b.setAttribute('aria-expanded', j === k); if (j === k) b.setAttribute('data-actif', ''); else b.removeAttribute('data-actif'); });
      panneaux.forEach(function (p, j) { if (j === k) p.setAttribute('data-actif', ''); else p.removeAttribute('data-actif'); });
      if (trait) trait.style.transform = 'translateX(' + (k * 100) + '%)';
    }
    boutons.forEach(function (b, k) { b.addEventListener('click', function () { activer(k); }); });
    activer(0);
    zone.setAttribute('data-pret', '');
    /* éditeur : sélectionner un bloc onglet l'affiche */
    document.addEventListener('shopify:block:select', function (e) { boutons.forEach(function (b, k) { if (b === e.target || b.contains(e.target)) activer(k); }); });
  }

  function lancer() {
    chaque(document.querySelectorAll('[data-fpb-badges]:not([data-pret])'), badges);
    chaque(document.querySelectorAll('[data-fpb-onglets]:not([data-pret])'), onglets);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  document.addEventListener('shopify:section:load', lancer);
  document.addEventListener('shopify:block:select', lancer);
  /* changement de couleur : la fiche est remplacée sans recharger la page */
  var attente = null;
  new MutationObserver(function () { clearTimeout(attente); attente = setTimeout(lancer, 30); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
